<template>
    <div>
        <transition name="lnkloading-fade">
            <div class="lnk-loading-modal" v-show="show">
                <div class="spinner">
                    <svg viewBox="0 0 120 120" version="1.1">
                        <g class="g-circles g-circles--v1">
                            <circle transform="translate(35, 16.698730) rotate(-30) translate(-35, -16.698730) " cx="35"
                                    cy="16.6987298" r="10"></circle>
                            <circle transform="translate(16.698730, 35) rotate(-60) translate(-16.698730, -35) "
                                    cx="16.6987298" cy="35" r="10"></circle>
                            <circle transform="translate(10, 60) rotate(-90) translate(-10, -60) " cx="10" cy="60"
                                    r="10"></circle>
                            <circle transform="translate(16.698730, 85) rotate(-120) translate(-16.698730, -85) "
                                    cx="16.6987298" cy="85" r="10"></circle>
                            <circle transform="translate(35, 103.301270) rotate(-150) translate(-35, -103.301270) "
                                    cx="35"
                                    cy="103.30127" r="10"></circle>
                            <circle cx="60" cy="110" r="10"></circle>
                            <circle transform="translate(85, 103.301270) rotate(-30) translate(-85, -103.301270) "
                                    cx="85"
                                    cy="103.30127" r="10"></circle>
                            <circle transform="translate(103.301270, 85) rotate(-60) translate(-103.301270, -85) "
                                    cx="103.30127" cy="85" r="10"></circle>
                            <circle transform="translate(110, 60) rotate(-90) translate(-110, -60) " cx="110" cy="60"
                                    r="10"></circle>
                            <circle transform="translate(103.301270, 35) rotate(-120) translate(-103.301270, -35) "
                                    cx="103.30127" cy="35" r="10"></circle>
                            <circle transform="translate(85, 16.698730) rotate(-150) translate(-85, -16.698730) "
                                    cx="85"
                                    cy="16.6987298" r="10"></circle>
                            <circle cx="60" cy="10" r="10"></circle>
                        </g>
                    </svg>
                </div>
                <div class="loading-text">{{message}}</div>
            </div>
        </transition>
    </div>
</template>

<script>
/* eslint-disable object-curly-newline,semi,indent */
    /**
     * @createdBy:HuangJian
     * @date:2018/12/5
     * @params：
     * @description：加载动画的原型
     */
    import {typeOf} from "@utils/linktools";

    export default {
        name: 'lnk-loading-modal',
        data() {
            return {
                index: 0,
                /* 加载状态的请求队列*/
                request: []
            }
        },
        computed: {
            show() {
                return this.request.length > 0;
            },
            message(){
                const result = this.request[0];
                return result && typeOf(result.message)==='string'?result.message:'正在加载…';
            }
        },
        methods: {
            requestShow(message) {
                this.request.push({
                    message: message,
                    index: this.index
                });
                return this.index++;
            },
            requestHide(tag) {
                if(this.request.length<1) {
                    return false;
                }
                var index = 0;
                if(typeOf(tag)==='number'){
                    var flag = false;
                    for(var i=0; i<this.request.length; i++) {
                        if(this.request[i].index === tag){
                            index = i;
                            flag=true;
                            break;
                        }
                    }
                    if(!flag) return false;
                }
                this.request.splice(index, 1);
                return true;
            },
            requestClose() {
                this.request = [];
                return true;
            }
        }
    }
</script>

<style>
    .lnkloading-fade-enter, .lnkloading-fade-leave-active {
        opacity: 0;
        -webkit-transform: translate(-50%, -100%);
        transform: translate(-50%, -100%)
    }

    .lnk-loading-modal {
        height: 32px;
        line-height: 30px;
        /* min-width: 200px; */
        background: white;
        border-radius: 2px;
        padding: 0 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        left: 50%;
        top: 10px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        position: fixed;
        z-index: 9999;
    }

    .lnk-loading-modal .spinner {
        width: fit-content;
        height: fit-content;
        position: relative;
        display: inline-block;
        top: 6px;
    }

    .lnk-loading-modal .loading-text {
        font-size: 12px;
        margin-left: 4px;
        display: inline-block;
        color: #000000;
        letter-spacing: 3px;
    }

    .lnk-loading-modal svg {
        height: 20px;
        width: 20px;
    }

    .lnk-loading-modal .g-circles {
        -webkit-transform: scale(0.9) translate(7px, 7px);
        -ms-transform: scale(0.9) translate(7px, 7px);
        transform: scale(0.9) translate(7px, 7px);
    }

    .lnk-loading-modal circle {
        fill: dodgerblue;
        fill-opacity: 0;
        -webkit-animation: opacity 1.2s linear infinite;
        animation: opacity 1.2s linear infinite;
    }

    .lnk-loading-modal circle:nth-child(12n + 1) {
        -webkit-animation-delay: -0.1s;
        animation-delay: -0.1s;
    }

    .lnk-loading-modal circle:nth-child(12n + 2) {
        -webkit-animation-delay: -0.2s;
        animation-delay: -0.2s;
    }

    .lnk-loading-modal circle:nth-child(12n + 3) {
        -webkit-animation-delay: -0.3s;
        animation-delay: -0.3s;
    }

    .lnk-loading-modal circle:nth-child(12n + 4) {
        -webkit-animation-delay: -0.4s;
        animation-delay: -0.4s;
    }

    .lnk-loading-modal circle:nth-child(12n + 5) {
        -webkit-animation-delay: -0.5s;
        animation-delay: -0.5s;
    }

    .lnk-loading-modal circle:nth-child(12n + 6) {
        -webkit-animation-delay: -0.6s;
        animation-delay: -0.6s;
    }

    .lnk-loading-modal circle:nth-child(12n + 7) {
        -webkit-animation-delay: -0.7s;
        animation-delay: -0.7s;
    }

    .lnk-loading-modal circle:nth-child(12n + 8) {
        -webkit-animation-delay: -0.8s;
        animation-delay: -0.8s;
    }

    .lnk-loading-modal circle:nth-child(12n + 9) {
        -webkit-animation-delay: -0.9s;
        animation-delay: -0.9s;
    }

    .lnk-loading-modal circle:nth-child(12n + 10) {
        -webkit-animation-delay: -1s;
        animation-delay: -1s;
    }

    .lnk-loading-modal circle:nth-child(12n + 11) {
        -webkit-animation-delay: -1.1s;
        animation-delay: -1.1s;
    }

    .lnk-loading-modal circle:nth-child(12n + 12) {
        -webkit-animation-delay: -1.2s;
        animation-delay: -1.2s;
    }

    @-webkit-keyframes opacity {
        3% {
            fill-opacity: 1;
        }

        75% {
            fill-opacity: 0;
        }
    }

    @keyframes opacity {
        3% {
            fill-opacity: 1;
        }

        75% {
            fill-opacity: 0;
        }
    }
</style>
